/* =========================================================
   MC ANCHOR MENU — JS (links + scrollspy + sticky + chevrons)
   - 1 init
   - même logique que ton script actuel
   ========================================================= */

(function () {
  // ---------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------
  function getAnchorOffset() {
    // Offset dynamique : header + hauteur du menu (si tu as un helper global)
    if (window.__MM_ANCHOR_OFFSET__) return window.__MM_ANCHOR_OFFSET__();
    return 170; // fallback
  }

  function getHeaderOffset() {
    const header =
      document.querySelector(".mm-header") ||
      document.querySelector("header") ||
      document.querySelector(".shopify-section-header");
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }

  // ---------------------------------------------------------
  // 1) Links + active + click scroll + IntersectionObserver
  // ---------------------------------------------------------
  function initAnchorLinks(menu) {
    // ⚠️ Important : on scope les links AU menu (sinon tu prends toutes les ancres du site)
    const links = Array.from(menu.querySelectorAll(".mc-anchor-link"));
    if (links.length === 0) return;

    // Map id -> section element
    const sections = {};
    links.forEach((link) => {
      const id = link.dataset.target;
      const el = document.getElementById(id);
      if (el) sections[id] = el;
    });

    function setActive(id) {
      links.forEach((l) =>
        l.classList.toggle("is-active", l.dataset.target === id)
      );
    }


    // 1) Click : scroll smooth + active immédiat
    links.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const id = link.dataset.target;
        const target = sections[id];
        if (!target) return;

        setActive(id);

        const rect = target.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const newTop = rect.top + scrollTop - getAnchorOffset();

        window.scrollTo({ top: newTop, behavior: "smooth" });
        history.pushState(null, "", "#" + id);
      });
    });

    // 2) Scroll : active automatique via IntersectionObserver
    let current = null;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((en) => en.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length === 0) return;

        const id = visible[0].target.id;
        if (id && id !== current) {
          current = id;
          setActive(id);
        }
      },
      {
        root: null,
        threshold: 0.1,
        // Décale la zone d’observation pour tenir compte du header + menu fixed
        rootMargin: `-${getAnchorOffset()}px 0px -60% 0px`,
      }
    );

    Object.values(sections).forEach((el) => observer.observe(el));

    // 3) Si on arrive avec un hash, on active le bon onglet
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      if (sections[id]) setActive(id);
      else activateClosestSection();
      } else {
        activateClosestSection();
    } 

    // classe la plus proche pour activer au refresh page
    function activateClosestSection() {
      let closest = null;
      let minDistance = Infinity;

      links.forEach(link => {
        const id = link.dataset.target;
        const section = document.getElementById(id);
        if (!section) return;

        const rect = section.getBoundingClientRect();
        const distance = Math.abs(rect.top);

        if (distance < minDistance) {
          minDistance = distance;
          closest = id;
        }
      });

      if (closest) {
        setActive(closest);
      } else if (links[0]) {
        // fallback ultime
        setActive(links[0].dataset.target);
      }
    }
  }

    
  // ---------------------------------------------------------
  // 2) Sticky (is-fixed) + spacer anti-jump + CSS var offset header
  // ---------------------------------------------------------
  function initSticky(menu) {
    // Spacer permanent = évite les jumps de layout
    const spacer = document.createElement("div");
    spacer.className = "mc-anchor-menu-spacer";
    menu.parentNode.insertBefore(spacer, menu);
    spacer.appendChild(menu);

    function sync() {
      const headerOffset = getHeaderOffset();
      document.documentElement.style.setProperty(
        "--mm-header-offset",
        headerOffset + "px"
      );
      spacer.style.height = menu.offsetHeight + "px"; // place toujours réservée
      return headerOffset;
    }

    let threshold = 0;
    let isFixed = false;
    const HYST = 20; // marge anti-tremblement

    function recomputeThreshold() {
      const headerOffset = sync();
      threshold =
        spacer.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    }

    function setFixed(on) {
      if (on === isFixed) return;
      isFixed = on;
      menu.classList.toggle("is-fixed", isFixed);
    }

    function onScroll() {
      const y = window.pageYOffset;

      // ON à threshold
      if (!isFixed && y >= threshold) setFixed(true);

      // OFF seulement si on remonte un peu au-dessus (hystérésis)
      if (isFixed && y <= threshold - HYST) setFixed(false);
    }

    recomputeThreshold();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      recomputeThreshold();
      onScroll();
    });

    onScroll();
  }

  // ---------------------------------------------------------
  // 3) Chevrons ← → (mobile) pour scroll horizontal du menu
  // ---------------------------------------------------------
  function initAnchorScrollHints(menu) {
    const list = menu.querySelector(".mc-anchor-menu-list");
    if (!list) return;

    const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

    const scroller = menu.querySelector(".mc-anchor-menu-inner") || menu;


    const canScroll = () => scroller.scrollWidth > scroller.clientWidth + 2;

    const ensureBtn = (selector, className, ariaLabel, text) => {
      let btn = menu.querySelector(selector);
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = className;
        btn.setAttribute("aria-label", ariaLabel);
        btn.textContent = text;
        menu.appendChild(btn);
      }
      return btn;
    };

    const btnLeft = ensureBtn(
      ".mc-anchor-scrollhint--left",
      "mc-anchor-scrollhint mc-anchor-scrollhint--left",
      "Voir à gauche",
      "‹"
    );

    const btnRight = ensureBtn(
      ".mc-anchor-scrollhint--right",
      "mc-anchor-scrollhint mc-anchor-scrollhint--right",
      "Voir à droite",
      "›"
    );

    const step = () => Math.round(scroller.clientWidth * 0.7);

    const bindOnce = (btn, handler) => {
      if (!btn || btn.dataset.bound) return;
      btn.addEventListener("click", handler);
      btn.dataset.bound = "1";
    };

    bindOnce(btnLeft, () =>
      scroller.scrollBy({ left: -step(), behavior: "smooth" })
    );
    bindOnce(btnRight, () =>
      scroller.scrollBy({ left: step(), behavior: "smooth" })
    );

    function syncBtns() {
      if (!isMobile() || !canScroll()) {
        btnLeft.classList.add("is-hidden");
        btnRight.classList.add("is-hidden");
        return;
      }

      const x = scroller.scrollLeft;
      const max = scroller.scrollWidth - scroller.clientWidth;

      btnLeft.classList.toggle("is-hidden", x <= 2);
      btnRight.classList.toggle("is-hidden", x >= max - 2);
    }

    syncBtns();
    scroller.addEventListener("scroll", syncBtns, { passive: true });
    window.addEventListener("resize", syncBtns);
  }

  // ---------------------------------------------------------
  // Init 
  // ---------------------------------------------------------
  function init() {
    const menu = document.querySelector(".mc-anchor-menu-wrapper");
    if (!menu) return;

    if (menu.dataset.anchorInit === "1") return;
    menu.dataset.anchorInit = "1";

    initAnchorLinks(menu);
    initSticky(menu);
    initAnchorScrollHints(menu);
  }

  // Avec <script defer>, le DOM est déjà parsé, mais on sécurise :
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
